"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

require("../../styles/_main.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import AssetLibrary from '../../common/components/AssetLibrary';


var Library = function Library(props) {
  var history = props.history;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_uiKit.PageHeader, {
    title: "Media Assets Library"
  }), _react.default.createElement(_commonReact.AssetLibrary, {
    history: history,
    isListEditable: true
  }));
};

var _default = Library;
exports.default = _default;